const AUTH_USER_KEY = "authUser";

export const getStoredAuthUser = () => {
  try {
    const raw = localStorage.getItem(AUTH_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const storeAuthUser = (user) => {
  if (!user) {
    localStorage.removeItem(AUTH_USER_KEY);
    return;
  }
  localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
};

export const clearAuthUser = () => {
  localStorage.removeItem(AUTH_USER_KEY);
};

export const normalizeAuthUser = (source) => {
  if (!source || typeof source !== "object") return null;

  const profile =
    source.company ||
    source.user ||
    source.profile ||
    (source.data && typeof source.data === "object" && !Array.isArray(source.data)
      ? source.data.company || source.data.user || source.data
      : source);

  if (!profile || typeof profile !== "object") return null;

  const companyProfile =
    source.company ||
    (source.data && typeof source.data === "object" && !Array.isArray(source.data)
      ? source.data.company
      : null);
  const isCompanyProfile = Boolean(
    companyProfile || profile.companyName || profile.companyEmail
  );
  const companyReference = profile.company;
  const companyId =
    profile.companyId?._id ||
    profile.companyId?.id ||
    profile.companyId ||
    profile.company_id ||
    companyReference?._id ||
    companyReference?.id ||
    (typeof companyReference === "string" ? companyReference : null) ||
    (isCompanyProfile ? profile._id || profile.id : null);

  const name =
    profile.name ||
    profile.companyName ||
    profile.fullName ||
    profile.username ||
    "";
  const email = profile.email || profile.companyEmail || "";

  if (!name && !email) return null;

  return {
    id: profile._id || profile.id || null,
    companyId: companyId || null,
    name: name || (email ? email.split("@")[0] : ""),
    email,
    logo: profile.logo || profile.logoPath || profile.profilePicture || "",
    visitingCard:
      profile.visitingCard ||
      profile.visitingCardPath ||
      profile.businessCard ||
      profile.businessCardPath ||
      "",
    // preserve all extra profile fields so pages like Profile can read them
    phone:       profile.phone       || profile.phoneNumber || "",
    location:    profile.location    || profile.address     || profile.city || "",
    website:     profile.website     || profile.websiteUrl  || profile.url  || "",
    companyName: profile.companyName || profile.company_name || name || "",
    designation: profile.designation || profile.role        || profile.type || "",
    role:        profile.role        || profile.designation || profile.type || "",
  };
};
